import { type ProHistoricalTransaction } from './ProHistoricalTransaction'
import { links } from '@/utils/link'
import { action } from 'mobx'

/**
 * View model for a single historical transaction in the list.
 */
export class ProHistoricalTransactionViewModel {
  constructor(public readonly transaction: ProHistoricalTransaction) {}

  /**
   * Views the job in a new window.
   */
  @action.bound
  viewJob() {
    if (this.transaction.job?.id) {
      window.open(links.job(this.transaction.job.id), '_blank')
    }
  }
}
